import { STORAGE_KEY_TOURIST_DEVICE_ID, STORAGE_KEY_SERVER_DEVICE_ID } from '@/constants/storage';

import { persistTripleValue, readStoredTriple, removeTripleValue } from './triple-storage';

export async function getTouristDeviceIdForRequest(): Promise<string | null> {
    return readStoredTriple(STORAGE_KEY_TOURIST_DEVICE_ID);
}

export function persistTouristDeviceId(deviceId: string): void {
    persistTripleValue(STORAGE_KEY_TOURIST_DEVICE_ID, deviceId);
}

export function getServerDeviceIdForRequest(): Promise<string | null> {
    return readStoredTriple(STORAGE_KEY_SERVER_DEVICE_ID);
}

export function persistServerDeviceId(deviceId: string): void {
    persistTripleValue(STORAGE_KEY_SERVER_DEVICE_ID, deviceId);
}

export function removeServerDeviceId(): void {
    removeTripleValue(STORAGE_KEY_SERVER_DEVICE_ID);
}
